import { EventBus } from "../../../eventbus";
import { thumbnail, errorPlaceholder } from "../../../functions/thumbnail";
import VueLoadImage from "vue-load-image";

export default {
  props: {
    type: String,
    checkBoxSettings: Object,
    hasFileOptions: Boolean,
    data: Object,
    layout: String,
    isPlaceholder: Boolean,
  },
  components: {
    "vue-load-image": VueLoadImage,
  },
  data() {
    return {
      imgLoaded: false,
    };
  },
  methods: {
    handleCloseSearch() {
      if (this.type === "search-view") {
        EventBus.$emit(`top-options-show`, {
          id: "search-overlay",
          show: false,
        });
      }
    },
    onImgLoad() {
      this.imgLoaded = true;

      EventBus.$emit(`file-list-layout`);
    },
    subText() {
      switch (this.type) {
        case "search-view":
          return `in ${this.data.folder} / ... /<strong class="label--small-bold">${this.data.name}</strong>`;

        case "file-view":
          return `Modified ${this.data.updated_at}`;

        default:
          return `Modified ${this.data.updated_at}`;
      }
    },
    handleClickItem(e) {
      e.preventDefault();

      if (this.data.extension == ".url") {
        //create a dumy link and open it
        this.openLink(this.data.location);
      } else {
        //update the url

        if (!this.$route.path.includes(this.data.id)) {
          this.$router.push(
            `/${this.$store.state.company}/${
              this.data.myspace ? "myspace" : "home"
            }/expanded/${this.data.folder_id}/${this.data.id}`
          );
        }

        //emit open detail
        EventBus.$emit("openOverlayPage", {
          id: "file-detail",
          file: this.data,
        });
      }
    },
    openLink(link) {
      const a = document.createElement("a");
      a.target = "_blank";
      a.href = link;
      a.click();
    },
    emit(name, data, e) {
      e.preventDefault();

      EventBus.$emit(name, data);
    },
    thumb(item, big = false) {
      return thumbnail(item, big);
    },
    onError(e) {
      errorPlaceholder(e);
    },
  },
  computed: {
    isActiveElem() {
      switch (this.layout) {
        case "list":
          return true;

        case "tile":
          return false;

        case "masonry":
          return false;

        default:
          return true;
      }
    },
  },
};
